import platform from 'Pub/js/platform';
import { getStore } from "Pub/js/storageUtils";
let { getMultiLang } = platform;
export const getMulti = ({
    moduleId,
    callback,
    domainName = 'workbench',
}) => {
    if (window.location.pathname.split('/').length == 2) {
        getMultiLang({
            environment: 'development',
            domainName,
            moduleId,
            callback,
        });
    } else {
        getMultiLang({
            environment: 'production',
            domainName,
            moduleId,
            callback,
        });
    }
};

/*
    获取当前登录语种的显示文本
    @params
    txtKey: 多语文本组件的attrcode
    data: 数据源
*/
export const getCurrentLangText = (txtKey, data) => {
    if (!txtKey || !data) { return ''; }

    if (typeof data[txtKey] === 'object') { // 对象格式 data: { name: { name: { value: '' }, name2: { value: '' } } }
        const obj = {};
        for (let k in data[txtKey]) {
            obj[k] = data[txtKey][k].value;
        }
        data = obj;
    }

    const languageMetas = getLanguageMetas();
    const currentLang = languageMetas.find(lang => lang.languageCode === window.CURRENT_LANG_CODE);
    let langText;
    if (currentLang) {
        langText = data[`${txtKey}${currentLang.index}`] || data[`${txtKey}`];
    }
    return langText || '';
};

// 获取当前语言index
export const getCurrentLangIndex = () => {
    const languageMetas = getLanguageMetas();
    let currentLang = languageMetas.find(lang => lang.languageCode === window.CURRENT_LANG_CODE);
    return currentLang ? currentLang.index : '';
};

/*
    获取多语文本组件的value
    @params
    txtKey: 多语文本组件的attrcode
    targetKey: 目标attrcode
    data: 数据源
*/
export const getMultiLangValue = (txtKey, data, targetKey) => {
    const result = {};
    if (!data) { return result; }

    if (typeof data[txtKey] === 'object') {
        return data[txtKey];
    }

    const languageMetas = getLanguageMetas();
    languageMetas.forEach(lang => {
        const valKey = txtKey + lang.index;
        const resultKey = (targetKey || txtKey) + lang.index;
        if (data[valKey]) {
            result[resultKey] = { value: data[valKey] };
        }
    });
    return result;
};

/*
    获取多语文本组件的languageMeta
*/
export const getLanguageMetas = () => {
    const infoData = getStore("STOREFORINFODATA", true);
    return infoData ? infoData.languageMetas || [] : [];
};

// 新增常用链接时 给多语设置默认名称

export const setDefaultTitle = (txtKey, name, flag) => {
    const result = {};
    const languageMetas = getLanguageMetas();
    languageMetas.forEach(lang => {
        const valKey = txtKey + lang.index;
        if (flag) {
            result[valKey] = { value: name };
        } else {
            result[valKey] = name;
        }
    });
    return result;
}